import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhMagnifierComponent } from './components/fh-magnifier.component';
import { FhLoadingModule } from '@fh-client-interaction-frontends/shared/ui/fh-loading';

@NgModule({
  imports: [CommonModule, FhLoadingModule],
  exports: [FhMagnifierComponent],
  declarations: [FhMagnifierComponent]
})
export class FhMagnifierModule {}
